export default "__VITE_ASSET__449c0ed8__"